interface RedirectArg {
  target: string
}

// Was a 303 from the Next server, or Router.replace on the client. With no server
// left, every redirect is the client one. `replace` rather than `assign` keeps the
// unresolvable page out of history, so Back does not bounce the user straight into
// it again -- the same effect the 303 had.
export const redirect = ({ target }: RedirectArg): void => {
  window.location.replace(target)
}
